import chargePointApi from 'api/chargePointApi';
import * as animationData from 'assets/charging_anim.json';
import AgencyHelper from 'features/Agency/agencyHelper';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import DialogEditChargeTransactionOdoView from 'features/Charge/ChargeTransaction/components/DialogEditChargeTransactionOdoView';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import ChargeTransactionHelper from 'features/ManageChargeTransaction/chargeTransactionHelper';
import { AppDialogHelper } from 'general/components/AppDialog';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Lottie from 'react-lottie';

ChargeTransactionDetailView.propTypes = {
  chargeTransactionId: PropTypes.string.isRequired,
};

const lottieDefaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

function ChargeTransactionDetailView(props) {
  // MARK: ---- PROPERTIES ----
  const { chargeTransactionId } = props;
  const { t } = useTranslation();
  const router = useRouter();
  const [chargeTransactionDetail, setChargeTransactionDetail] = useState({});
  useEffect(() => {
    fetchChargeTransactionDetail(chargeTransactionId);
  }, [chargeTransactionId]);
  const [chargedTimeText, setChargedTimeText] = useState('');
  const [reservedTimeText, setReservedTimeText] = useState('');
  const [chargePricing, setChargePricing] = useState();
  useEffect(() => {
    const updateChargeTimeText = () => {
      const detail = chargeTransactionDetail;
      if (ChargeTransactionHelper.isReserved(detail?.status)) {
        setReservedTimeText(
          Utils.convertSecondsToMS(
            Utils.calculateReservedTimeInSeconds(detail?.reservationEndTime)
          )
        );
        return;
      }
      setReservedTimeText('');
      setChargedTimeText(
        Utils.convertSecondsToHMS(
          Utils.calculateChargeTimeInSeconds(detail?.startTime, detail?.endTime)
        )
      );
    };
    // setChargePricing(chargeTransactionDetail?.pricing);
    setChargePricing(chargeTransactionDetail?.currentPricing);
    updateChargeTimeText();
    var timerApi;
    var timerClock;
    if (
      !ChargeTransactionHelper.isFinished(chargeTransactionDetail?.status) &&
      !ChargeTransactionHelper.isCancelled(chargeTransactionDetail?.status) &&
      !ChargeTransactionHelper.isFailed(chargeTransactionDetail?.status)
    ) {
      timerApi = setInterval(() => {
        fetchChargeTransactionDetail(chargeTransactionDetail?.transactionId);
      }, AppConfigs.timeIntervalGetChargeTransactionDetail);
    }
    if (ChargeTransactionHelper.isCharging(chargeTransactionDetail?.status)) {
      timerClock = setInterval(() => {
        const str = Utils.convertSecondsToHMS(
          Utils.calculateChargeTimeInSeconds(
            chargeTransactionDetail?.startTime,
            chargeTransactionDetail?.endTime
          )
        );
        setChargedTimeText(str);
      }, 1000);
    }
    if (ChargeTransactionHelper.isReserved(chargeTransactionDetail?.status)) {
      timerClock = setInterval(() => {
        const str = Utils.convertSecondsToMS(
          Utils.calculateReservedTimeInSeconds(
            chargeTransactionDetail?.reservationEndTime
          )
        );
        setReservedTimeText(str);
      }, 1000);
    }
    return () => {
      if (timerApi) clearInterval(timerApi);
      if (timerClock) clearInterval(timerClock);
    };
  }, [chargeTransactionDetail]);
  const [stoppingCharge, setStoppingCharge] = useState(false);

  // MARK: ---- METHODS ----
  const fetchChargeTransactionDetail = async (id) => {
    try {
      ChargeTransactionHelper.callApiGetChargeTransactionDetail(id).then((data) => {
        setChargeTransactionDetail({ ...chargeTransactionDetail, ...data });
      });
    } catch (error) { }
  };
  const buildOverviewItem = (icon, name, value, color) => {
    return (
      <div className="d-flex align-items-center gap-3">
        <div
          className="w-60px h-60px d-flex align-items-center justify-content-center"
          style={{
            borderRadius: '15px',
            backgroundColor: color,
          }}
        >
          <i className={`${icon} text-white fa-2x`} />
        </div>
        <div className="d-flex flex-column">
          <span style={UIHelper.buildFontStyle('700', '20px', AppColors.gray[800])}>{value}</span>
          <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}>{name}</span>
        </div>
      </div>
    );
  };
  const buildStatusBadge = (status, percent, additionalDescription) => {
    return (
      <KTTooltip
        text={additionalDescription}
        textHeader=""
        isHtmlContent
      >
        <div
          className={`px-5 py-2 d-flex align-items-center gap-2 rounded-5 bg-${ChargeTransactionHelper.getChargeTransactionStatusColor(
            status
          )}`}
        >
          {status === AppConstants.chargeTransactionStatus.charging && (
            <i className="fa-solid fa-bolt" style={{ color: 'white' }} />
          )}

          <span style={UIHelper.buildFontStyle('600', '16px', 'white')}>
            {[AppConstants.chargeTransactionStatus.charging, AppConstants.chargeTransactionStatus.finished].includes(status) ? `${percent}%` : ''}{' '}
            {status ? t(`chargeStatus_${status}`).toUpperCase() : 'Không xác định'}
          </span>
        </div>
      </KTTooltip>
    );
  };
  const buildStatusImage = (status) => {
    if (ChargeTransactionHelper.isCharging(status)) {
      return <Lottie options={lottieDefaultOptions} width="90%" />;
    }
    if (
      [
        AppConstants.chargeTransactionStatus.finishing,
        AppConstants.chargeTransactionStatus.finished,
      ].includes(status)
    ) {
      return (
        <img
          src={AppResource.images.evg.transactionStatusFinished}
          alt="done"
          style={{ width: '90%' }}
        />
      );
    }
    if ([AppConstants.chargeTransactionStatus.cancelled].includes(status)) {
      return (
        <img
          src={AppResource.images.evg.transactionStatusCancelled}
          alt="done"
          style={{ width: '90%' }}
        />
      );
    }
    if ([AppConstants.chargeTransactionStatus.reserved].includes(status)) {
      return (
        <img
          src={AppResource.images.evg.transactionStatusReserved}
          alt="done"
          style={{ width: '90%' }}
        />
      );
    }
    return <div></div>;
  };
  const handleStopCharge = () => {
    AppDialogHelper.show(
      t('stopCharge'),
      t('textConfirmStopCharge'),
      [
        {
          title: t('cancel'),
          type: 'neutral',
          onClick: () => {
            AppDialogHelper.hide();
          },
        },
        {
          title: t('confirm'),
          type: 'positive',
          onClick: async () => {
            AppDialogHelper.hide();
            setStoppingCharge(true);
            try {
              const res = await chargePointApi.stopChargerByTransactionId(chargeTransactionId);
              const { result, reason } = res;
              if (result == 'success') {
                ToastHelper.showSuccess(t('stopChargerSuccess'));
                router.navigate(-1);
              } else {
                ToastHelper.showError(reason);
              }
            } catch (error) { }
            setStoppingCharge(false);
          },
        },
      ],
      false,
      AppResource.images.dialogIcons.dialogStopCharge
    );
  };
  const handleCancelReserved = () => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        iconEl={<img src={AppResource.images.dialogIcons.dialogError} />}
        title="Hủy đặt chỗ"
        contentEl={
          <>
            Bạn có chắc muốn hủy đặt chỗ của phiên sạc{' '}
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
              {chargeTransactionDetail?.transactionCode}
            </span>
            {' '}không?
          </>
        }
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onConfirm={async () => {
          const res = await ChargeHelper.API.ChargeTransaction.requestCancelReservedTransaction({ transactionId: chargeTransactionDetail?.transactionId });
          if (res && _.isBoolean(res)) {
            ToastHelper.showSuccess('Hủy đặt chỗ thành công');
            fetchChargeTransactionDetail(chargeTransactionDetail?.transactionId);
            AppCustomDialogHelper.hide();
          } else {
            ToastHelper.showError(res);
          }
        }}
        confirmButtonRed={true}
        cancelButtonText='Bỏ qua'
        confirmButtonText='Hủy'
      />,
      'md',
      false,
      true
    );
  };
  const handleCreateInvoice = async () => {
    const transactionId = chargeTransactionDetail?.transactionId;
    if (!transactionId) return;

    if (Utils.isValid(chargeTransactionDetail?.invoiceSerial) && !Utils.isValid(chargeTransactionDetail?.invoiceDocument)) {
      ToastHelper.showError('Đã xuất hoá đơn nhưng chưa tạo được file PDF');
      return;
    }
    const res = await ChargeHelper.API.ChargeTransaction.requestCreateInvoiceChargeTransaction({
      transactionId,
    });

    if (res && _.isBoolean(res)) {
      ToastHelper.showSuccess('Xuất hóa đơn thành công');
      fetchChargeTransactionDetail(transactionId);
    } else {
      ToastHelper.showError('Xuất hóa đơn thất bại');
    }
  };
  const handleOpenEditOdoModal = () => {
    const transactionId = chargeTransactionDetail?.transactionId;
    if (!transactionId) return;
    AppCustomDialogHelper.show(
      'Sửa số ODO',
      <DialogEditChargeTransactionOdoView
        transactionId={String(transactionId)}
        initialOdo={chargeTransactionDetail?.odo}
        initialOdoImage={chargeTransactionDetail?.odoImage}
        onUpdated={() => {
          AppCustomDialogHelper.hide();
          fetchChargeTransactionDetail(transactionId);
        }}
      />,
      'md',
      false,
      true
    );
  };
  const [chargeStationInvestor, setChargeStationInvestor] = useState(null);
  const [chargeStationLandlord, setChargeStationLandlord] = useState(null);
  useEffect(() => {
    const agencyId = chargeTransactionDetail?.chargeStation?.agencyId;
    const landlordId = chargeTransactionDetail?.chargeStation?.landlordId;
    if (agencyId) {
      AgencyHelper.API.requestAgencyDetail(agencyId).then((agency) => {
        if (agency && _.isObject(agency)) {
          setChargeStationInvestor(agency);
        }
      });
    }
    if (landlordId) {
      AgencyHelper.API.requestAgencyDetail(landlordId).then((agency) => {
        if (agency && _.isObject(agency)) {
          setChargeStationLandlord(agency);
        }
      });
    }
  }, [chargeTransactionDetail]);

  // show danh sach phien sac su dung voucher
  const VoucherListTable = (vouchers) => {
    const textHeader = ['Voucher áp dụng', 'Số tiền giảm'];

    let html = `
    <div>
      <div class="row m-0 position-relative py-2 bg-white rounded-lg">
        <div class="rounded-lg p-0" style="border: 1px solid #EBEDEF">
          <table class="w-100" style="border-collapse: collapse">
            <thead>
              <tr style="background-color: #F7F7FD; font-size: 12px; color: #494968">
  `;

    textHeader.forEach((header, index) => {
      const align = index === 0 ? 'text-left' : 'text-right';
      const minWidth = index === 0 ? '200px' : '150px';

      html += `
      <th
        class="p-3 ${align}"
        style="min-width: ${minWidth}; font-weight: bold; padding: 12px 16px;"
      >
        ${header}
      </th>
    `;
    });

    html += `
              </tr>
            </thead>
            <tbody>
  `;

    if (vouchers?.length > 0) {
      vouchers.forEach(item => {
        html += `
        <tr style="border-top: 1px solid #EBEDEF">
          <td
            class="p-3 text-left"
            style="padding: 12px 16px;"
          >
            ${item?.voucher?.voucherCode ?? '--'}
          </td>

          <td
            class="p-3 text-right"
            style="padding: 12px 16px;"
          >
            -${Utils.formatNumber(item?.valueUsed ?? 0)} VNĐ
          </td>
        </tr>
      `;
      });
    } else {
      html += `
      <tr>
        <td colspan="2" class="p-3 text-center">
          Không có dữ liệu để hiển thị
        </td>
      </tr>
    `;
    }

    html += `
            </tbody>
          </table>
        </div>
      </div>
    </div>
  `;

    return html;
  };

  return (
    <div className="px-2">
      <div className="row m-0 p-0">
        {/* thong tin tong quan */}
        <div className="col-xl-4 mb-4 px-2 d-flex flex-column">
          {UIHelper.buildCard(
            <div>
              <div className="d-flex flex-column align-items-center py-5 gap-4">
                {/* animation & image */}
                {buildStatusImage(chargeTransactionDetail?.status)}
                {/* trang thai */}
                <div>
                  {buildStatusBadge(
                    chargeTransactionDetail?.status,
                    chargeTransactionDetail?.percentComplete,
                    chargeTransactionDetail?.status === ChargeConstants.ChargeTransactionStatus.CANCELLED ? chargeTransactionDetail?.reason : '',
                  )}
                </div>
              </div>

              <div className="pb-4">
                {/* chi phi sac */}
                <div className="d-flex flex-column align-items-center">
                  <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[700])}>
                    {chargeTransactionDetail?.status === ChargeConstants.ChargeTransactionStatus.FINISHED
                      ? 'Phí sạc thực tế'
                      : chargeTransactionDetail?.status === ChargeConstants.ChargeTransactionStatus.RESERVED
                        ? 'Thời gian còn lại'
                        : 'Số tiền đã sạc'}
                  </span>
                  <span style={UIHelper.buildFontStyle('700', '26px',
                    chargeTransactionDetail?.status === ChargeConstants.ChargeTransactionStatus.RESERVED ? AppColors.danger : AppColors.primary
                  )}>
                    {chargeTransactionDetail?.status === ChargeConstants.ChargeTransactionStatus.FINISHED
                      ? Utils.formatNumber(chargeTransactionDetail?.totalCost) + ' VNĐ'
                      : chargeTransactionDetail?.status === ChargeConstants.ChargeTransactionStatus.RESERVED
                        ? reservedTimeText
                        : Utils.formatNumber(chargeTransactionDetail?.estimatedEnergyCost) + ' VNĐ'}
                  </span>

                  {ChargeTransactionHelper.isCharging(chargeTransactionDetail?.status) &&
                    UIHelper.buildRedButton(
                      'Ngừng sạc',
                      handleStopCharge,
                      <i className="fa-regular fa-power-off" />,
                      false,
                      stoppingCharge
                    )}
                  {ChargeTransactionHelper.isFinished(chargeTransactionDetail?.status) &&
                    !Utils.isValid(chargeTransactionDetail?.invoiceDocument) && (
                      <div className='px-4'>
                        {UIHelper.buildBlueButton(
                          'Xuất hóa đơn',
                          handleCreateInvoice,
                          <i className='far fa-file-export' style={{ fontSize: 15 }} />
                        )}
                      </div>
                    )}
                  {ChargeTransactionHelper.isReserved(chargeTransactionDetail?.status) &&
                    UIHelper.buildRedButton(
                      'Hủy đặt chỗ',
                      handleCancelReserved,
                      <i className="fa-regular fa-close" />,
                    )}
                </div>
              </div>
            </div>,
            false,
            false,
            true
          )}

          {/* thong tin thanh toan */}
          <div className="mt-4" style={{ flex: '1 1 auto' }}>
            {UIHelper.buildCard(
              <div style={{ height: '100%' }}>
                {UIHelper.buildCardHeader('Thông tin thanh toán', false, null, true)}
                <div
                  className="mx-4 mb-4"
                  style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    borderRadius: '5px',
                  }}
                >
                  {UIHelper.buildCardCellItem(
                    'Số tiền đã sạc',
                    Utils.formatNumber(Math.round(chargeTransactionDetail?.estimatedEnergyCost / (1 - chargeTransactionDetail?.discountRate))) + ' VNĐ'
                  )}
                  {UIHelper.buildCardCellItem(
                    'Phí sạc quá giờ',
                    Utils.formatNumber(chargeTransactionDetail?.estimatedOverchargeCost) + ' VNĐ'
                  )}
                  {UIHelper.buildCardCellItem(
                    'Phí đặt giữ chỗ',
                    Utils.formatNumber(chargeTransactionDetail?.reservationFee ?? 0) + ' VNĐ'
                  )}
                  {UIHelper.buildCardCellItem(
                    'Chiết khấu',
                    '-' +
                    Utils.formatNumber(
                      Math.round(
                        chargeTransactionDetail?.discountRate * chargeTransactionDetail?.estimatedEnergyCost / (1 - chargeTransactionDetail?.discountRate)
                      )
                    ) +
                    ' VNĐ'
                  )}
                  {UIHelper.buildCardCellItem(
                    <div className="d-flex align-items-center">
                      <span className='mr-2'>Voucher giảm giá</span>

                      <KTTooltip
                        offset={[0, 0]}
                        text={VoucherListTable(chargeTransactionDetail?.voucherTransactions)}
                        textHeader="Voucher giảm giá"
                        isHtmlContent
                      >
                        <i className="fa-regular fa-info-circle" style={{ color: AppColors.info }} />
                      </KTTooltip>
                    </div>,
                    '-' +
                    Utils.formatNumber(chargeTransactionDetail?.appliedVoucherAmount) + ' VNĐ'
                  )}
                  {UIHelper.buildCardCellItem(
                    'Tổng thanh toán',
                    Utils.formatNumber(chargeTransactionDetail?.totalCost - chargeTransactionDetail?.appliedVoucherAmount) + ' VNĐ',
                    null,
                    false,
                    700,
                    '14px',
                    AppColors.danger
                  )}
                </div>
              </div>,
              false,
              false,
              true,
              true
            )}
          </div>
        </div>

        {/* thong tin phien sac */}
        <div className="col-xl-4 mb-4 px-2 d-flex flex-column">
          <div style={{ flex: '1 1 auto' }}>
            {UIHelper.buildCard(
              <div style={{ height: '100%' }}>
                {UIHelper.buildCardHeader('Thông tin phiên sạc', false, null, true)}
                <div
                  className="mx-4 mb-4"
                  style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    borderRadius: '5px',
                  }}
                >
                  {UIHelper.buildCardCellItem('Mã phiên sạc', chargeTransactionDetail?.transactionCode)}
                  {UIHelper.buildCardCellItem(
                    'Số điện đã sạc',
                    `${Utils.formatNumber(((chargeTransactionDetail?.energy ?? 0) / 1000).toFixed(3))} kWh`
                  )}
                  {UIHelper.buildCardCellItem(
                    'Thời gian bắt đầu',
                    Utils.formatDateTimeToString(chargeTransactionDetail?.startTime, 'DD/MM/YYYY - HH:mm:ss')
                  )}
                  {UIHelper.buildCardCellItem(
                    'Thời gian kết thúc',
                    Utils.formatDateTimeToString(chargeTransactionDetail?.endTime, 'DD/MM/YYYY - HH:mm:ss')
                  )}
                  {UIHelper.buildCardCellItem(
                    'Thời gian đã sạc',
                    !ChargeTransactionHelper.isReserved(chargeTransactionDetail?.status) ? chargedTimeText : ''
                  )}
                  {chargePricing?.pricingMode === ChargeConstants.ChargePricingMode.FLAT &&
                    UIHelper.buildCardCellItem(
                      'Đơn giá',
                      chargePricing?.flatPrice
                        ? Utils.formatNumber(chargePricing?.flatPrice) + ' VNĐ/kWh'
                        : ''
                    )}
                  {UIHelper.buildCardCellItem(
                      'Giá giờ bình thường',
                      chargePricing?.normalPrice
                        ? Utils.formatNumber(chargePricing?.normalPrice) + ' VNĐ/kWh'
                        : ''
                    )}
                  {UIHelper.buildCardCellItem(
                      'Giá giờ cao điểm',
                      chargePricing?.peakPrice
                        ? Utils.formatNumber(chargePricing?.peakPrice) + ' VNĐ/kWh'
                        : ''
                    )}
                  {UIHelper.buildCardCellItem(
                      'Giá giờ thấp điểm',
                      chargePricing?.offPeakPrice
                        ? Utils.formatNumber(chargePricing?.offPeakPrice) + ' VNĐ/kWh'
                        : ''
                    )}
                  {UIHelper.buildCardCellItem(
                    'Thời gian sạc quá giờ',
                    !ChargeTransactionHelper.isReserved(chargeTransactionDetail?.status)
                      ? Utils.convertSecondsToHMS(
                        (chargeTransactionDetail?.holdDuration - chargePricing?.freeOverchargeDuration) > 0
                          ? chargeTransactionDetail?.holdDuration - chargePricing?.freeOverchargeDuration
                          : 0
                      ) +
                      ' - ' +
                      `(${chargePricing?.overchargePrice
                        ? Utils.formatNumber(chargePricing?.overchargePrice) + ' VNĐ/phút'
                        : ''
                      })`
                      : '',
                    null,
                    false
                  )}
                </div>
              </div>
            )}
          </div>

          {/* thong tin xe sac */}
          <div className="mt-4" style={{ flex: '1 1 auto' }}>
            {UIHelper.buildCard(
              <div>
                {UIHelper.buildCardHeader('Thông tin xe sạc', false, null, true)}
                <div
                  className="mx-4 mb-4"
                  style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    borderRadius: '5px',
                  }}
                >
                  {UIHelper.buildCardCellItem(
                    'Loại phương tiện',
                    chargeTransactionDetail?.vehicle?.vehicleType ? t(`vehicleType_${chargeTransactionDetail?.vehicle?.vehicleType}`) : ''
                  )}
                  {UIHelper.buildCardCellItem('Dòng xe', chargeTransactionDetail?.vehicle?.model?.name)}
                  {UIHelper.buildCardCellItem(
                    'Hãng xe',
                    chargeTransactionDetail?.vehicle?.model?.brand?.name
                  )}
                  {UIHelper.buildCardCellItem(
                    'Biến số xe',
                    chargeTransactionDetail?.vehicle?.plate,
                    chargeTransactionDetail?.vehicle?.vehicleId == 0
                      ? null
                      : () => {
                        Utils.openInNewTab(
                          `${AppRoute.vehicleList}/${chargeTransactionDetail?.vehicle?.vehicleId}`
                        );
                      }
                  )}
                  {UIHelper.buildCardCellItem(
                    'Tên tài khoản chủ xe',
                    chargeTransactionDetail?.user?.fullname,
                    () => {
                      Utils.openInNewTab(
                        `${AppRoute.customerList}/${chargeTransactionDetail?.user?.userId}`
                      );
                    }
                  )}
                  {UIHelper.buildCardCellItem(
                    'Mã tài khoản',
                    chargeTransactionDetail?.user?.userCode?.toString(),
                    () => {
                      Utils.openInNewTab(
                        `${AppRoute.customerList}/${chargeTransactionDetail?.user?.userId}`
                      );
                    }
                  )}
                  {UIHelper.buildCardCellItem('Số điện thoại', chargeTransactionDetail?.user?.phone)}
                  {UIHelper.buildCardCellItem('Email', chargeTransactionDetail?.user?.email)}
                  {UIHelper.buildCardCellItem(
                    'Thẻ RFID',
                    chargeTransactionDetail?.chargeRFID?.idTag,
                    () => {
                      Utils.openInNewTab(`${AppRoute.rfidList}`);
                    },
                    false
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* thong tin he thong */}
        <div className="col-xl-4 mb-4 px-2 d-flex flex-column">
          <div style={{ flex: '1 1 auto' }}>
            {UIHelper.buildCard(
              <div>
                {UIHelper.buildCardHeader('Thông tin hệ thống', false, null, true)}
                <div
                  className="mx-4 mb-4"
                  style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    borderRadius: '5px',
                  }}
                >
                  {UIHelper.buildCardCellItem(
                    'SOC bắt đầu',
                    chargeTransactionDetail?.startSoc != null && chargeTransactionDetail?.startSoc !== ''
                      ? `${chargeTransactionDetail.startSoc}%`
                      : ''
                  )}
                  {UIHelper.buildCardCellItem(
                    'SOC kết thúc',
                    chargeTransactionDetail?.endSoc != null && chargeTransactionDetail?.endSoc !== ''
                      ? `${chargeTransactionDetail.endSoc} %`
                      : ''
                  )}
                  {UIHelper.buildCardCellItem(
                    'ODO ',                   
                    chargeTransactionDetail?.odo != null && chargeTransactionDetail?.odo !== ''
                      ? `${Utils.formatNumber(chargeTransactionDetail.odo)} Km`
                      : ''
                  )}
                  {UIHelper.buildCardCellItem(
                    <span className="d-inline-flex align-items-center">
                      Ảnh ODO      
                      <i
                        className="fa-regular fa-edit ml-2 cursor-pointer"
                        style={{
                          color: AppColors.gray[800],
                          fontSize: 14,
                        }}
                        role="button"
                        tabIndex={0}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleOpenEditOdoModal();
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleOpenEditOdoModal();
                          }
                        }}
                      />            
                    </span>,                   
                    Array.isArray(chargeTransactionDetail?.odoImage)
                      ? chargeTransactionDetail?.odoImage?.length
                        ? `Xem ảnh ODO (${chargeTransactionDetail?.odoImage?.length})`
                        : ''
                      : Utils.isValid(chargeTransactionDetail?.odoImage)
                        ? 'Xem ảnh ODO'
                        : '',
                    () => {
                      const odoImage = chargeTransactionDetail?.odoImage;
                      if (Array.isArray(odoImage)) {
                        if (odoImage.length) DealerHelper.handleShowFile(odoImage);
                      } else if (Utils.isValid(odoImage)) {
                        DealerHelper.handleShowImage('Ảnh ODO', Utils.getFullUrl(odoImage));
                      }
                    },
                  )}
                  {UIHelper.buildCardCellItem(
                    'Điện áp',
                    chargeTransactionDetail?.voltage != null
                      ? `${chargeTransactionDetail?.voltage} V`
                      : ''
                  )}
                  {UIHelper.buildCardCellItem(
                    'Công suất hiện tại',
                    chargeTransactionDetail?.power != null
                      ? `${chargeTransactionDetail.power / 1000} kW`
                      : ''
                  )}
                  {UIHelper.buildCardCellItem(
                    'Dòng điện',
                    chargeTransactionDetail?.current != null
                      ? `${chargeTransactionDetail?.current} A`
                      : ''
                  )}
                  {UIHelper.buildCardCellItem(
                    'Loại vòi sạc',
                    ChargeHelper.Utils.getChargeConnectorTypeName(chargeTransactionDetail?.chargeConnector?.type)
                  )}
                  {UIHelper.buildCardCellItem(
                    'Tên vòi sạc',
                    chargeTransactionDetail?.chargeConnector?.name
                  )}
                  {UIHelper.buildCardCellItem(
                    'Tên trụ sạc',
                    chargeTransactionDetail?.chargeConnector?.chargePoint?.name,
                    () => {
                      Utils.openInNewTab(
                        `${AppRoute.stationList}/${chargeTransactionDetail?.chargeStation?.stationId}/point/${chargeTransactionDetail?.chargeConnector?.chargePoint?.pointId}`
                      );
                    }
                  )}
                  {UIHelper.buildCardCellItem(
                    'Hãng sản xuất trụ sạc',
                    chargeTransactionDetail?.chargeConnector?.chargePoint?.chargeModel?.chargeBrand?.name,
                    () => {
                      Utils.openInNewTab(`${AppRoute.manageChargeBrand}/${chargeTransactionDetail?.chargeConnector?.chargePoint?.chargeModel?.brandId}`);
                    }
                  )}
                  {UIHelper.buildCardCellItem(
                    'Loại trụ sạc',
                    chargeTransactionDetail?.chargeConnector?.chargePoint?.type
                  )}
                  {UIHelper.buildCardCellItem(
                    'Model',
                    chargeTransactionDetail?.chargeConnector?.chargePoint?.chargeModel?.name,
                  )}
                  {UIHelper.buildCardCellItem(
                    'Đối tác',
                    Utils.isValid(chargeTransactionDetail?.chargeStation?.agencyId)
                      ? chargeStationInvestor?.name
                      : Utils.isValid(chargeTransactionDetail?.chargeStation?.landlordId)
                        ? chargeStationLandlord?.name
                        : '',
                    () => {
                      AgencyHelper.Navigation.navigateToAgencyDetail(
                        null,
                        chargeTransactionDetail?.chargeStation?.agencyId
                          ? chargeStationInvestor
                          : chargeStationLandlord
                      );
                    },
                  )}
                  {UIHelper.buildCardCellItem(
                    'Trạm sạc',
                    chargeTransactionDetail?.chargeStation?.name,
                    () => {
                      Utils.openInNewTab(
                        `${AppRoute.stationList}/${chargeTransactionDetail?.chargeStation?.stationId}`
                      );
                    }
                  )}
                  {UIHelper.buildCardCellItem(
                    'Địa chỉ',
                    ChargeHelper.Utils.getChargeStationFullAddress(
                      chargeTransactionDetail?.chargeStation
                    )
                  )}
                  {UIHelper.buildCardCellItem(
                    'Hoá đơn',
                    Utils.isValid(chargeTransactionDetail?.invoiceDocument)
                      ? 'Xem hoá đơn'
                      : Utils.isValid(chargeTransactionDetail?.invoiceSerial)
                        ? 'Đã xuất hoá đơn nhưng chưa tạo được file PDF'
                        : 'Chưa xuất hoá đơn',
                    Utils.isValid(chargeTransactionDetail?.invoiceDocument)
                      ? () => {
                        Utils.openInNewTab(chargeTransactionDetail?.invoiceDocument);
                      }
                      : null,
                    false
                  )}
                </div>
              </div>,
              false,
              false,
              true,
              true
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChargeTransactionDetailView;
